import React, { FunctionComponent } from 'react';
import { Box } from '@mui/material';
import { IntlProvider } from 'react-intl';
import { useLocale } from '../contexts/LocaleProvider';
import WhatsNew from './homePage/whatsnew/WhatsNew';
import Hero from './homePage/herosection/Hero';
import Solutions from './homePage/solutions/Solutions';
import { useDevice } from '../contexts/DeviceContext';
import Sustainability from './homePage/sustainability/Sustainability';
import SubstainabilitySmallLayout from './homePage/sustainability/SustainabilitySmallLayout';
import DebouncedLoader from './common/DebouncedLoader';
import Infographic from './homePage/infographic/Infographic';
import { getCurrentLayout } from '../utils/ChooseLayout';
import { useHomePageContent } from '../graphql/pimcore/modules/siteContent/hooks/useHomePageContent';
import InfoBannerList from './common/InfoBannerList';

const HomePage: FunctionComponent = () => {
    const { loading, error, contentTree: homePageContent } = useHomePageContent();
    const { width } = useDevice();
    const layout = getCurrentLayout(width);
    const { locale, messages } = useLocale();
    if (error && !loading) {
        return <div className="mid-width">Error: {error.message}</div>;
    }
    return (
        <DebouncedLoader loading={loading} delay={1000} size={40} centered={true}>
            <IntlProvider locale={locale} key={locale} defaultLocale="en" messages={messages}>
                <Box width={width} component="main" sx={{ padding: 0, flexGrow: 0, p: 0 }}>
                    <Hero cmsContent={homePageContent.HeroSection} />
                    <WhatsNew />
                    <Solutions cmsContent={homePageContent.Applications} />
                    {layout.includes('large') ? (
                        <Sustainability cmsContent={homePageContent.Sustainability} />
                    ) : (
                        <SubstainabilitySmallLayout cmsContent={homePageContent.Sustainability} />
                    )}
                    <Infographic cmsContent={homePageContent.InfographicSection} />
                    <InfoBannerList banners={homePageContent.InfoBanner.infoBanners} />
                </Box>
            </IntlProvider>
        </DebouncedLoader>
    );
};

export default HomePage;
